import React from 'react';
import { NavLink, useLocation  } from 'react-router-dom';
import Header4 from './../Common/Header4';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import Projects7 from './../Elements/Projects7';
import { Helmet } from 'react-helmet-async';
import withRouterData from '../Common/withRouterData';
import {getImageUrl, STORAGE_KEY, devitems } from './../Common/Helpers';




var bnrimg = require('./../../images/banner/bg-fichas.jpg');




class ProjectDetail2 extends React.Component {
    
 
    constructor(props) {
        super(props);
        this.state = {
            projectData: null,
            loading: true,
            error: null,
        };
    }


    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        //loadScript('./assets/js/custom.js'); '/demos/noviembre/assets/js/custom.js'
        loadScript('./assets/js/custom.js');

        this.findProjectFromStorage();

    };

    componentDidUpdate(prevProps) {
            const currentSlug = this.props.router.params.slug;
            const prevSlug = prevProps.router.params.slug;
            
            if (currentSlug !== prevSlug) {
                this.findProjectFromStorage();
            }
        }    

    findProjectFromStorage = () => {
        this.setState({ loading: true, error: null });
        
        // 1. Obtener el slug y extraer el ID
        const slug = this.props.router.params.slug;
        const targetId = parseInt(slug.split('-')[0], 10);
        
        if (isNaN(targetId)) {
            this.setState({ loading: false, error: "ID de ficha no válido en la URL." });
            return;
        }

        // 2. Leer la lista completa de proyectos desde localStorage
        const storedData = devitems;//localStorage.getItem(STORAGE_KEY);
        //console.info(storedData.length);
        
        if (devitems.length >= 1) {
            try {
                // const projects = JSON.parse(storedData);
                // console.info(projects);
                
                // 3. Buscar el proyecto por el ID extraído
                const foundProject = devitems.find(p => p.id === targetId);

                this.setState({
                    projectData: foundProject,
                    loading: false
                });
                //console.log(`Búsqueda exitosa desde localStorage para ID: ${targetId}`);
                
            } catch (e) {
                this.setState({ loading: false, error: "Error al parsear datos de sesión." });
                console.error("Error al parsear datos de sesión.");
            }
        } else {
            this.setState({ loading: false, error: "No se encontraron fichas guardados en la sesión." });
        }
    };    
    
    render() {
        const imageContext = require.context('./../../images/projects/iden/thub/', false, /\.jpg$/);

       // const projects = this.props.location?.state?.projects;
        //console.info(projectData);
        //this.findProjectFromStorage();
        //const projectData = this.props.location?.state?.projectData;   
        const { loading, projectData, error } = this.state;     
        if (!projectData) {
            //let DataSession = this.getState({projectData});
            //console.info(DataSession);

            return (
                <div style={{ padding: '20px', border: '1px solid red' }}>
                    <h2>Error: Ficha no encontrada</h2>
                    <p>No se encontraron datos de la ficha en la navegación. Por favor, regrese a la lista.</p>
                </div>
            );
        }

        // Desestructuramos los datos para usarlos en el renderizado
        const { id, image, imagedt, title, address, filter, Nombre, motivodeceso, clasifdelito, estatus, Edad, SEXO, profesion, CAUSA, fechadeceso, 
                causapreiml, centropenal, recluidopordelito, lugareconociron, regionresidia, departamento  } = projectData;        
        //console.info(projectData);
        //console.info(projects);
        const startId = id + 1;
        const texto =    `Nombre : ${Nombre}` ;
        const texto2 = <p>Ciudad: {regionresidia}, Departamento: {departamento} </p> ;
        const texto3 = <p>Fecha de deceso: {fechadeceso}</p>

        const dominio = "https://memoria.laprensagrafica.com/";
        const fullTitle = `${Nombre} - Víctima del régimen de excepción de El Salvador | La Prensa Gráfica`;
        //Titulo de la ficha: ${Nombre} - Víctima del régimen de excepción de El Salvador | La Prensa Gráfica
        const projectURL = `${dominio}/ficha/${this.props.router.params.slug}`;
        var titulo1 = "MEMORIAL DEL RÉGIMEN: ";
        var titulo2 = "FALLECIDOS EN LAS CÁRCELES DE EL SALVADOR ";                

        

        return (
            <>
{/* 
                <Helmet>
                    <title>{fullTitle}</title>
                    <meta name="description" content={fullTitle.substring(0, 160)} />
                    <meta property="og:title" content={fullTitle} />
                    <meta property="og:description" content={fullTitle.substring(0, 160)} />
                    <meta property="og:url" content={projectURL} />
                    <meta property="og:type" content="article" />
                    <meta property="og:image" content={`${dominio}${bnrimg}`} />
                    <meta property="og:site_name" content="La Prensa Gráfica" />
                    <meta name="twitter:card" content="Cuenta oficial del periódico La Prensa Gráfica, fundado en 1915 en El Salvador" />
                    <meta name="twitter:site" content="@prensagrafica" /> 
                </Helmet>  */}             
                 <Header4 />
                <div className="page-content"> 
                    <Banner title1={titulo1} title2={titulo2}  pagename={estatus} description={{texto,texto2, texto3}} bgimage={bnrimg} />

                    {/* SECTION CONTENT START */}
                    <div className="section-full p-tb80 inner-page-padding stick_in_parent">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="project-detail-outer row">
                                        <div className="col">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
{/*                                                     <img src={require('./../../images/projects/square/pic8.jpg')} alt="" /> */}
{/*                                                     <img src={imageContext(`./${id + "pearch.jpg"}`)} alt="" /> */}
                                                    <img src={getImageUrl(id + "pearch.jpg", SEXO)} alt="" />
                                                </div>
                                            </div>
                                        </div>
{/*                                         <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={require('./../../images/projects/square/pic9.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={require('./../../images/projects/square/pic10.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={require('./../../images/projects/square/pic7.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={require('./../../images/projects/square/pic2.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="project-detail-pic m-b30">
                                                <div className="sx-media">
                                                    <img src={require('./../../images/projects/square/pic3.jpg')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="sx-box">
                                                <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                                                    <img src="https://img.youtube.com/vi/Oy2QIiSQT2U/0.jpg" alt="" />
                                                    <NavLink to={"#"} className="play-now" data-toggle="modal" data-target="#myModal">
                                                        <i className="icon fa fa-play" />
                                                        <span className="ripple" />
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12  sticky_column">
                                    <div className="project-detail-containt-2">
                                        <div className="bg-white text-black p-a20 shadow">
                                            <div className="product-block bg-gray p-a30 m-b30">
                                                <ul>
                                                    <li>
                                                        <h4 className="sx-title">{Nombre}</h4>
                                                        <p><b>Edad:</b>  {Edad}</p>
                                                        <p><b>Género:</b> {SEXO}</p>
                                                        <p><b>Profesión:</b> {profesion}</p>
                                                        <p><b>Lugar de residencia:</b> {regionresidia}, {departamento}</p>
                                                    </li>
                                                    <li>
                                                        <h4 className="sx-title">Fecha y causa de deceso</h4>
                                                        <p> <b>Fecha de deceso:</b> {fechadeceso}</p>
                                                        <p><b>Causa de muerte:</b>  {CAUSA}</p>                                                        
                                                        <p><b>Causa preliminar de deceso según IML:</b> {causapreiml}</p>
                                                        <p><b>Motivo del deceso:</b> {motivodeceso}</p>
                                                        <p><b>Lugar donde le reconocieron:</b> {lugareconociron}</p>
                                                    </li>
                                                    <li>
                                                        <h4 className="sx-title">Centro penal y delito por el que estaba recluido</h4>
                                                        <p><b>Centro Penal:</b> {centropenal}</p>
                                                        <p><b>Delito por el que estaba recluido:</b> {recluidopordelito}</p>
                                                        <p><b>Clasificación de delito:</b> {clasifdelito}</p>
                                                        <p><b>Estatus del proceso:</b> {estatus}</p>
                                                    </li>
                                                </ul>
                                            </div>
{/*                                             <h4>Landscape plans for drainage problems may also entail planting beds away from the home’s foundation.</h4>
                                            <p> Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression.</p> <p>The most powerful men have always inspired the architects; the architect has always been influenced by power.</p>
                                            <div className="m-b0">
                                                <div className="sx-divider divider-1px  bg-black"><i className="icon-dot c-square" /></div>
                                            </div>
                                            <ul className="social-icons social-square social-darkest m-b0">
                                                <li><a href="https://www.facebook.com" target="_blank" className="fa fa-facebook" /></li>
                                                <li><a href="https://twitter.com" target="_blank" className="fa fa-twitter" /></li>
                                                <li><a href="https://in.linkedin.com" target="_blank" className="fa fa-linkedin" /></li>
                                                <li><a href="https://rss.com" target="_blank" className="fa fa-rss" /></li>
                                                <li><a href="https://www.youtube.com" target="_blank" className="fa fa-youtube" /></li>
                                                <li><a href="https://www.instagram.com" target="_blank" className="fa fa-instagram" /></li>
                                            </ul> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* SECTION CONTENT END  */}
                    <Projects7 startId={startId}  />
                </div>

{/*                 <div className="modal fade" id="myModal2" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <ReactPlayer url='https://www.youtube.com/watch?v=Oy2QIiSQT2U' />
                        </div>
                    </div>
                </div> */}
                <Footer />
            </>
        );
    };
};

//export default ProjectDetail2;
export default withRouterData(ProjectDetail2);